import { useTranslation } from "@redotech/redo-i18n";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import * as NodeCSS from "./node.module.css";

const NUMBER_FORMAT = new Intl.NumberFormat();
const CURRENCY_FORMAT = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export const TrackingPageAnalyticsBlock = memo(
  function TrackingPageAnalyticsBlock({
    opens,
    clicks,
    revenue,
  }: {
    opens: number | undefined;
    clicks: number | undefined;
    revenue: number | undefined;
  }) {
    const { t } = useTranslation();

    return (
      <Flex className={NodeCSS.analytics}>
        <Flex dir="column" gap="sm" w="full">
          <MetricRow
            label={t("Opens")}
            value={
              typeof opens === "number" ? NUMBER_FORMAT.format(opens) : "-"
            }
          />
          <MetricRow
            label={t("Clicks")}
            value={
              typeof clicks === "number" ? NUMBER_FORMAT.format(clicks) : "-"
            }
          />
          <MetricRow
            label={t("Revenue")}
            value={
              typeof revenue === "number"
                ? CURRENCY_FORMAT.format(revenue)
                : "-"
            }
          />
        </Flex>
      </Flex>
    );
  },
);

const MetricRow = memo(function MetricRow({
  label,
  value,
}: {
  label: string;
  value: string;
}) {
  return (
    <Flex justify="space-between">
      <Text fontSize="xs">{label}</Text>
      <Text fontSize="xs" fontWeight="semibold">
        {value}
      </Text>
    </Flex>
  );
});
